import { Link } from 'react-router-dom';
import { useReviewSummary } from '../api/review';

/** Three different questions, which used to be one page.
 *
 * Proofreading a card, judging a store match and finding what a shop cannot
 * buy need different things in front of you — the card, the product, the
 * shelf — and interleaving them meant every screen carried two thirds of what
 * you did not need.
 */
export default function Review() {
  const { data: summary } = useReviewSummary();

  return (
    <section className="review">
      <h1>Check the extraction</h1>

      {summary && (
        <p className="review-summary">
          <strong>{summary.verified_rows.toLocaleString()}</strong> of{' '}
          {summary.ingredient_rows.toLocaleString()} rows checked ·{' '}
          <strong>{summary.priced_ingredients.toLocaleString()}</strong> of{' '}
          {summary.canonical_ingredients.toLocaleString()} ingredients priced ·{' '}
          <strong>{summary.human_verdicts.toLocaleString()}</strong> match
          {summary.human_verdicts === 1 ? '' : 'es'} you have ruled on
        </p>
      )}

      <ul className="review-modes">
        <li>
          <Link to="/review/cards">
            <strong>Did we read the card right?</strong>
            <span className="muted">
              The printed ingredient list with the rows we read off it
              underneath. Catches wrong amounts, wrong units and dropped lines.
            </span>
          </Link>
        </li>
        <li>
          <Link to="/review/matches">
            <strong>Is this the right product?</strong>
            <span className="muted">
              One row per ingredient, with each candidate's photograph, price
              and a link to the shop's own page. Most-used ingredients first.
            </span>
          </Link>
        </li>
        <li>
          <Link to="/review/stores">
            <strong>What can each shop actually buy?</strong>
            <span className="muted">
              Coverage per store, and the ingredients standing between you and
              the most dinners.
            </span>
          </Link>
        </li>
      </ul>
    </section>
  );
}
